import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IGeneralErrorDialogComponent } from '@app/shared/models/dialog/general-error-dialog';

@Component({
  selector: 'app-general-error-dialog',
  templateUrl: './general-error-dialog.component.html',
  styleUrls: ['./general-error-dialog.component.scss'],
})
export class GeneralErrorDialogComponent {
  public descriptionText = '';

  constructor(@Inject(MAT_DIALOG_DATA) private data: IGeneralErrorDialogComponent) {
    this.descriptionText = this.data.descriptionText;
  }
}
